class RenderContainer extends createjs.Container {
  constructor() {
    super();
    this.render = {};
    this.render.once = true;
    this.render.stream = false;
  }

  needRender() {
    let ret = false || this.render.once || this.render.stream;
    this.children.forEach(child => {
      if (child.render) {
        if (child.needRender()) {
          ret = true;
        }
      }
    });
    return ret;
  }

  rendered() {
    this.children.forEach(child => {
      if (child.render) {
        child.rendered();
      }
    });
    if (this.render.stream) {
      // console.log(this);
      this.render.once = true;
    } else {
      this.render.once = false;
    }
  }

  static clipImageSizeToSize(bmp, size) {
    const scaleX = size.width / bmp.image.width;
    const scaleY = size.height / bmp.image.height;

    if (scaleX > scaleY) {
      bmp.scaleX = scaleY;
      bmp.scaleY = scaleY;
    } else {
      bmp.scaleX = scaleX;
      bmp.scaleY = scaleX;
    }
    return {
      height: size.height * bmp.scaleY,
      width: size.width * bmp.scaleX
    };
  }

  static centerOnSelfSelf(container, distance) {
    container.x =
      distance.x / 2.0 - (container.image.width * container.scaleX) / 2.0;
    container.y =
      distance.y / 2.0 - (container.image.height * container.scaleY) / 2.0;
  }

  clipImageSizeToSize(image) {
    this.originalImageHeight = image.height;
    this.originalImageWidth = image.width;

    const scaleX = this.width / this.originalImageWidth;
    const scaleY = this.height / this.originalImageHeight;

    if (scaleX > scaleY) {
      this.scaleX = scaleY;
      this.scaleY = scaleY;
    } else {
      this.scaleX = scaleX;
      this.scaleY = scaleX;
    }
    this.height = image.height * this.scaleY;
    this.width = image.width * this.scaleX;
    this.render.once = true;
    this.setBounds(this.x, this.y, this.width, this.height);
  }

  centerOnSelf() {
    this.y = this.y - this.height / 2.0;
    this.x = this.x - this.width / 2.0;
    this.render.once = true;
    this.setBounds(this.x, this.y, this.width, this.height);
  }
}

export { RenderContainer as default };
